import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from '../styles';
import { formatMonthDateYearWithoutUTC } from '@dataGrid/gridUtilities';
import { pluralize, getStopTime } from '../../../../DriverPopUp/common/utils';
import ClosingSoonBadge from '../../../../../Common/ClosingSoonBadge';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import Details from './components/Details';
import { getFormattedPickupStatusToggleInfo, isUnassignedNoFreightPickup } from '../../utils';
import { getNoFreightStatusLabel } from '../../../../../../Dispatch/utils/utils';
import { getPickupStatus } from '../../../../utils/pickupStatusTypeIcon';

@inject('DispatchStore')
@observer
class PickupStatusDetails extends React.Component {
  render() {
    const {
      classes,
      data,
      groupMemberPickups,
      DispatchStore,
      configJSON: {
        closingSoonWarningTimeLimit,
        closingSoonAlertTimeLimit,
        newPickupDuration,
        noFreightConfigParsed,
        enableReturnExceptionReasonLabels
      }
    } = this.props;
    const { staticClientData } = DispatchStore;
    const enableNoFreightCode = noFreightConfigParsed?.enableNoFreightCode
    const closingSoonLimitConfig = {
      closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit
    };
    const pickupStatusToggleList = getFormattedPickupStatusToggleInfo(data);
    const stopTime = getStopTime(data.arrivalTime, data.departureTime);
    const groupStatusData =
      groupMemberPickups?.length && data.groupAggregatedData
        ? { ...data, ...data.groupAggregatedData }
        : data;
    const status = groupMemberPickups?.length
      ? getPickupStatus({
          pickup: groupStatusData,
          terminalOffset: DispatchStore.terminalOffset,
          newPickupDuration
        })
      : data.status;
    const isUnassignedNoFreight = isUnassignedNoFreightPickup(
      groupStatusData.isNoFreight,
      groupStatusData.driverNumber
    );
    const statusTitle = this.props.statusTitle || 'Pickup Status';
    const groupHeaderPickupId = data.pickupIdList?.join(', ');
    const closingSoonPickupId = groupMemberPickups?.length
      ? groupHeaderPickupId || data.pickupId
      : data.pickupId;
    const closingSoonTimeToCloseInMins = DispatchStore.getClosingSoonPickupTime(closingSoonPickupId);
    return (
      <div>
        <div className={classes.statusTitleContainer}>
          <div className={classes.sectionTitle}>{statusTitle}</div>
          {data.pickupId || (groupMemberPickups && groupMemberPickups.length > 0) ? (
            <ClosingSoonBadge
              timeToCloseInMins={closingSoonTimeToCloseInMins}
              closingSoonLimitConfig={closingSoonLimitConfig}
            />
          ) : null}
        </div>
        <div className={classes.infoContainer}>
          <div className={classes.statusRowContainer}>
            <Details
              title="Status"
              value={groupStatusData.isNoFreight ? `${status} (NF)` : status}
              showBoldValue
              isTopSection
            />
            {groupStatusData.isNoFreight && (
              // contactName(assigned pickup NF flow), customerName (Unassigned pickup NF flow)
              <>
              <Details title="NF Contact" value={data.contactName || data.customerName} isTopSection />
              {enableNoFreightCode && data.noFreightCode && (
                  <Details
                    title={`NF Reason ${enableReturnExceptionReasonLabels ? 'Description' : 'Code'}`}
                    value={getNoFreightStatusLabel(
                      data.noFreightCode,
                      staticClientData?.clientCodes?.noFreightCode,
                      enableReturnExceptionReasonLabels
                    )}
                    isTopSection
                  />
                )}
              </>
            )}
            {isUnassignedNoFreight && <Details title="Call Time" value={data.callTime} isTopSection />}
            {(data.isVoided || isUnassignedNoFreight) && <Details title="Comments" value={data.comment} isTopSection />}
            {data.isVoided && (
              <Details title="Void Reason" value={data.voidedReason} isTopSection />
            )}
          </div>
          <div className={classes.timeRowContainer}>
            <Details title="Ready Time" value={data.pickupReadyTime} />
            <Details title="Close Time" value={data.pickupCloseTime} />
            <Details
              title="Date"
              value={formatMonthDateYearWithoutUTC({ value: data.pickupDate })}
            />
            {data.driverNumber && (
              <>
                <Details title="Arr Time" value={data.arrivalTime} />
                <Details title="Dept Time" value={data.departureTime} />
                <Details
                  title="Stop Time"
                  value={stopTime ? pluralize(stopTime, 'MIN', 'S') : ''}
                />
              </>
            )}
          </div>
          {pickupStatusToggleList.length ? (
            <div className={classes.shipperLoadRowContainer}>
              {pickupStatusToggleList.map(({ label, value, ...rest }, index) => (
                <Details title={label} value={value} key={index} {...rest} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(PickupStatusDetails);
